// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"EmptyState_wrapper__YT3LE","cross":"EmptyState_cross__C1LNG","children":"EmptyState_children__atK_O"};